export const electricityAuthorityRoute = {
  loadChildren: () =>
    import('./electricity-authority.module').then(m => m.ElectricityAuthorityPageModule)
};
